import React, { useState, useEffect } from 'react';
import {
    Building,
    FolderArchive,
    Users
} from 'lucide-react';

const Folder = ({ searchKey, idCustomer }) => {
    const [folders, setFolders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [totalFolders, setTotalFolders] = useState(0);

    // Fonction pour récupérer les folders
    const fetchFolders = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await fetch('https://search.mg.formafusion.io/api/search/folders', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    key: searchKey,
                    idCustomer: idCustomer,
                }),
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            const data = await response.json();

            setFolders(data.folders || []);
            setTotalFolders(data.folder_count || 0);
        } catch (error) {
            console.error('Erreur lors de la récupération des folders:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (searchKey, idCustomer) {
            fetchFolders();
        }
    }, [searchKey, idCustomer]);

    // Composant de chargement
    if (loading) {
        return (
            <div classNameName="flex items-center justify-center h-64">
                <div classNameName="w-12 h-12 border-b-2 border-purple-600 rounded-full animate-spin"></div>
            </div>
        );
    }

    // Composant d'erreur
    if (error) {
        return (
            <div classNameName="p-4 text-center text-red-500">
                <p>Erreur: {error}</p>
                <button
                    onClick={fetchFolders}
                    classNameName="px-4 py-2 mt-2 text-white bg-purple-600 rounded hover:bg-purple-700"
                >
                    Réessayer
                </button>
            </div>
        );
    }

    // Aucun client trouvé
    if (!folders || folders.length === 0) {
        return (
            <div classNameName="p-8 text-center text-gray-500">
                <Building classNameName="w-12 h-12 mx-auto mb-4 text-gray-400" />
                <p>Aucun client trouvé.</p>
            </div>
        );
    }

    return (
        <main id="main" className="flex-grow">
            <div className="bg-white rounded-lg shadow">
                <div className="overflow-x-auto" id="divTable">
                    <table id="fileTable" className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Dossier</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Types</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Modules</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Ville</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Docs</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Projet</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    <Users className="inline-block w-4 h-4 mr-1 font-medium" />
                                </th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Période</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Statut</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Montant</th>
                                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                    Paie</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {folders.map((folder) =>
                                <tr className="cursor-pointer hover:bg-gray-50" data-id="203" data-year="2025" data-month="7" onclick="voirDossier(event, this)">
                                    <td className="px-6 py-4">
                                        <div className="flex items-center">
                                            <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 bg-purple-100 rounded-lg">
                                                <FolderArchive className="w-6 h-6 text-purple-600" />
                                            </div>
                                            <div className="ml-4">
                                                <div className="text-sm font-medium text-gray-900">{folder.nomDossier}</div>
                                                <div className="flex flex-wrap gap-1 mt-1">
                                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">{folder.entreprises}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-500">
                                        <div className="flex items-center">
                                            <i className="w-4 h-4 mr-2 text-sm text-gray-400 fa-regular fa-user-group" aria-hidden="true"></i>
                                            <div className="flex flex-wrap gap-1 mt-1">
                                                <span className="inline-flex items-center">{folder.typeProjets}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-500">
                                        {folder.modules}
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="flex items-center text-sm text-gray-500">
                                            <i className="w-4 h-4 mr-2 text-sm text-gray-400 fa-regular fa-location-dot" aria-hidden="true"></i>
                                            <span>{folder.villes}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-sm text-center text-gray-500">0</td>
                                    <td className="px-6 py-4 text-sm text-center text-gray-500">1</td>
                                    <td className="px-6 py-4 text-sm text-center text-gray-500">0</td>
                                    <td className="px-6 py-4">
                                        <div className="flex items-center text-sm text-gray-500">
                                            <i className="w-4 h-4 mr-2 text-sm text-gray-400 fa-regular fa-calendar" aria-hidden="true"></i>
                                            <span>{folder.dates.dateDebut} - {folder.dates.dateFin}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full">{folder.status}</span>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="flex items-center justify-between gap-1 text-sm font-medium text-gray-900 whitespace-nowrap">
                                            <span className="text-gray-500">MGA</span>
                                            <span>{folder.prix}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-center invoice-status">
                                        <i className="text-red-500 fa-solid fa-circle-xmark" data-bs-toggle="tooltip" data-bs-original-title="Non payé" aria-hidden="true"></i>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </main>
    );
};

export default Folder;